import BForm from "@/components/singles/BForm/component.vue";

export default {
  name: "login",
  components: {
    BForm
  },
  props: [],
  data() {
    return {
      isLoading: false,
      code: null,
      form: {
        valid: false,
        inputs: [
          {
            focus: true,
            icon: "fa-user",
            name: "username",
            placeholder: "Email",
            type: "text",
            validation: "required|email",
            value: ""
          }
        ]
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    async Send() {
      if (this.form.valid && !this.isLoading) {
        this.isLoading = true;
        try {
          let data = await this.$helpers.PostApi(
            "user/sendpasswordlink",
            {
              username: this.form.inputs[0].value
            },
            true
          );

          this.Successful(data);
        } catch (err) {
          this.Error(err);
        }
      }
    },

    Successful(data) {
      this.code = data.code;
      this.isLoading = false;
      this.$helpers.ClearForm(this.form);
    },

    Error(err) {
      this.isLoading = false;
      this.$helpers.ClearForm(this.form);

      this.$helpers.ShowStatus("Could not send mail.", 3000, "warning");
    }
  }
};
